export const Profile = {
  Members: {
    Languages: [
      "English",
      "Persian",
      "Afrikaans",
      "Arabic",
      "Azerbaijani",
      "Turkish",
      "Bulgarian",
      "Tibetan",
      "Bosnian",
      "Catalan",
      "Czech",
      "Chuvash (Russia)",
      "Kashubian (Poland)",
      "Welsh",
      "Danish",
      "German",
      "Greek",
      "Spanish",
      "Estonian",
      "Finnish (Finland)",
      "Filipino (Philippines)",
      "French",
      "Irish",
      "Western Frisian (Netherlands)",
      "Italian",
      "Gusii",
      "Hawaiian",
      "Hindi",
      "Croatian",
      "Haitian",
      "Hungarian (Hungary)",
      "Armenian",
      "Indonesian ",
      "Icelandic",
      "Japanese ",
      "Georgian",
      "Kazakh (Kazakhstan)",
      "Cornish",
      "Luxembourgish ",
      "Mongolian (Mongolia)",
      "Malay (Malaysia)",
      "Nama (Namibia)",
      "Nepali ",
      "Dutch",
      "Punjabi ",
      "Polish ",
      "Pashto ",
      "Portuguese",
      "Romansh ",
      "Romanian",
      "Russian ",
      "Kinyarwanda",
      "Slovak",
      "Slovenian ",
      "Somali",
      "Albanian ",
      "Serbian",
      "Swati (South Africa)",
      "Swedish",
      "Thai",
      "Uzbek",
      "Vunjo",
      "Yoruba",
      "Chinese",
      "Zulu",
    ],
    ExpenseAnalysisReportType:{Actual:"Actual", Forecast: "Forecast"},
    ClinetProfileLimit: 10,
    FavoriteSkillLimit: 5,

    SkillExperienceList: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "+20"],
    CareerHistoryEmploymentType: [
      "Full-time (40 hours per week)",
      "Part-time (20 hours per week)",
      "Hourly (Up to 10 hours per week)",
      "Contract",
      "Freelance",
      "Self-employed",
      "Internship",
      "Apprenticeship",
      "Seasonal",
    ],
    EmploymentTypes: [
      "Full-time (40 hours per week)",
      "Part-time (20 hours per week)",
      "Hourly (Up to 10 hours per week)",
      "Contract",
      "Internship",
      "Apprenticeship",
      "Seasonal",
    ],
    LocationTypes: ["On-site", "Hybrid", "Remote"],
    ProfessionalDetailLevel: ["Junior", "Mid level", "Senior", "Lead", "Manager", "Director", "Executive"],
    SeniorityLevels: [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14, 14.5, 15],
    JobTitles: [
      "C# Developer",
      "Python Developer",
      "Ui Developer",
      "Backend Developer",
      "C++ Developer",
      "Java Developer",
      "PHP Developer",
      "Swift Developer",
      "Res-Lang Developer",
      "Go Developer",
      "Object Pascal Developer",
      "Jquery",
      "Mobile Developer",
      "IOT",
      "Network",
      "UX Designer",
      "Security",
      "Game Developer",
      "React Developer",
      "Wordpress",
      "Full stack Developer",
      "Blockchain Developer",
      "AI Developer",
      "AR/VR Developer",
      "UWP/WPF Developer",
      "Testing",
      "Delphi Developer",
      "Perl Developer",
      "Visual basic Developer",
      "Seo",
      "Photoshop",
      "Data structure",
      "Elm Developer",
      "Ruby Developer",
      ".Net Developer",
      "Kotlin Developer",
      "Objective-c Developer",
      "Digital Marketing",
    ],
  },
  RequestTypes: {
    JSON: "application/json",
    MULTIPART: "multipart/form-data",
  },
  ErrorSetting: {
    SnackbarTimeout: 5000,
  },
};
